import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/ca14de7f-fad1-4cf0-be97-2618fa3e7ab9";
export const REGISTER_URL = "https://a.ntrk2.com/ea4d059a-da44-42a6-a44a-75c78e9ce1df";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://gogope.kzw2a.com/download?openExternalBrowser=1&id=tmelcumstxi8o1d";

export * from "./codes";
export * from "./context";
